export default "__VITE_ASSET__B068T96Q__"